import { BrowserRouter } from 'react-router-dom'
import { WithRoutes } from './ui'

export function Routing(){
    return (
        <BrowserRouter 
            future={{
                v7_startTransition: true,
                v7_relativeSplatPath: true
            }}
        >
            <WithRoutes/>
        </BrowserRouter>
    )
}